import { QueryClient } from '@tanstack/react-query';

/**
 * Cliente do TanStack Query do app (era criado dentro do `App.tsx`).
 *
 * Exportado para o harness do tutorial (`src/tutorial/testing`) zerar o cache
 * entre uma tela e outra — cada tela tem as proprias respostas de exemplo.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
